import { axios, httpWithAuth } from '~/clients';
import {
  CANCEL_PREORDER,
  CANCEL_PURCHASE,
  SUBSCRIBE_TO_VEHICLE_AVAILABILITY
} from '~/constants/endpoints';
import { type ContactType } from '~/constants/vdp/signUpForAlerts';
import { BrowserCookies } from '~/utilities';

export const cancelPurchase = () =>
  httpWithAuth.post(CANCEL_PURCHASE, {
    reasons: ['CustomerSelfCancelled'],
    notes: '',
    executeReturnVehicle: false
  });

type CancelPreorderParams = {
  notes?: string;
  vehicleId: number;
};

export const cancelPreOrder = ({
  notes = '',
  vehicleId
}: CancelPreorderParams) =>
  httpWithAuth.post(CANCEL_PREORDER, {
    vehicleId,
    notes,
    reasons: ['CustomerSelfCancelled']
  });

export const subscribeToVehicleAvailability = (
  contactValue: string,
  contactType: ContactType,
  vehicleId: number
) =>
  axios.post(`${SUBSCRIBE_TO_VEHICLE_AVAILABILITY}`, {
    contactValue,
    contactType,
    vehicleId,
    browserCookieId: BrowserCookies.get('BrowserCookieId') || null
  });
